import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app"

export default defineNuxtRouteMiddleware(to => {
  return navigateTo("/studie/landing", {
    redirectCode: 301,
  })
})
